import * as Yup from 'yup';

export enum MembershipFormFieldTypes {
	TextField = 'TextField',
	PasswordField = 'PasswordField',
	PasswordFieldWithStrength = 'PasswordFieldWithStrength',
	Select = 'Select',
	CheckboxField = 'CheckboxField',
	DateField = 'DateField',
	AddressesField = 'AddressesField',
	ContactsField = 'ContactsField'
}

export type MembershipFormField = {
	name: string;
	label: React.ReactNode;
	fieldType: MembershipFormFieldTypes;
};

export interface MembershipFormTemplateProps<T> {
	submitFunction: (values: T) => Promise<Response>;
	fields: MembershipFormField[];
	initialValues: T;
	validationSchema: Yup.ObjectSchema<object & T, object>;
	submitButtonText: string;
	recaptcha: string;
	contentId?: string;
	onSuccessFullSubmit?: () => void;
	successMessage?: React.ReactNode;
}

export type Link = {
	url?: string;
	target?: string;
};

export type SwiftFoxCustomField = {
	customFieldId: string;
	displayName: string;
	editable?: boolean;
};

export type CustomFieldValue = SwiftFoxCustomField & {
	type: string;
	meta: string;
	value: unknown;
};

export type SwiftFoxPersonDetails = {
	swiftFoxId: string;
	title: string;
	firstName: string;
	lastName: string;
	otherNames: string;
	dob: Date;
	addresses: Address[];
	contactDetails: ContactDetail[];
	customFields: CustomFieldValue[];
};

export type SwiftFoxOrganisationDetails = {
	swiftFoxId: string;
	name: string;
	addresses: Address[];
	contactDetails: ContactDetail[];
	customFields: CustomFieldValue[];
};

export type ContactDetail = {
	id?: number | null;
	trackingId?: string; //to keep track of it on the front end
	type: string;
	value: string;
	isAPrimaryContact: boolean;
	replace?: boolean;
};

export interface Address {
	id?: number | null;
	sourceId?: number;
	trackingId?: string; //to keep track of it on the front end
	addressTypeName: string;
	addressTypeId: number;
	formatted: string;
	rawAddressInput: string;
	address1: string;
	building: string;
	locality: string;
	postcode: string;
	state: string;
	country: string;
	lat: number | null;
	lng: number | null;
	isPrimary: boolean;
}

export interface SwiftFoxEntitySummary {
	name: string;
	firstName?: string;
	lastName?: string;
	primaryEmail?: string;
	primaryAddress?: Address;
}

export interface CustomFieldEditProps {
	customField: CustomFieldValue;
	onChange?: (customFieldId: string, value: unknown) => void;
	readonly?: boolean;
}

interface SwiftFoxEntity {
	id: string;
	type: string;
}

export interface SwiftFoxSearchResult {
	entity: SwiftFoxEntity;
	name: string;
	image: string;
	extraDetails: string;
}

export interface FileUploadCustomFieldValue {
	files: { url: string; fileName: string; mime: string; size?: number }[];
}
